//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectCoordinateSystem.js";
import "../no/SelectBodyList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AlignType",1,0],[0,"Associative",1,0],[0,"AxisVector",1,"Direction",0],[0,"BlankPrecisionValue",1,0],[0,"BlankSize",1,0],[1,"Clearance",0,"Expression",0],[0,"ConnectionString",1,0],[0,"CreateFeature",1,0],[0,"CreateFeatureBody",1,0],[0,"CylinderType",1,1],[0,"InputSymmetricValue",1,0],[0,"IsClearanceAutoSet",1,0],[0,"OffsetNegativeX",1,0],[0,"OffsetNegativeY",1,0],[0,"OffsetNegativeZ",1,0],[0,"OffsetPositiveX",1,0],[0,"OffsetPositiveY",1,0],[0,"OffsetPositiveZ",1,0],[0,"RadialOffset",1,0],[0,"RefCsys",1,"CoordinateSystem",1],[1,"RefCsysSelection",0,"SelectCoordinateSystem",0],[0,"ReferenceCsysType",1,0],[1,"SelectBody",0,"SelectBodyList",0],[0,"ShowDiameterSymbol",1,0],[0,"SizePrecision",1,0],[0,"StockType",1,1],[0,"StringStock",1,0],[0,"Type",1,0]],[[["inputOrigin","inputMatrix"],"ModifyRefCsys",{},2,0],[["inputOrigin","inputMatrix"],"CreateRefCsys",{},2,0],[["workPart"],"EditStockSizeAttr",{},1,0],[[],"UpdateBlankSizeString",{},0,0],[[],"UpdateStockSizeString",{},0,0],[["minPoint","nEdge","edgeLength","cysMatrix"],"CalculateBoxSize",{},0,0],[["cysMatrix"],"SetManipulatorOrientation",{},1,0],[["fitFace"],"SetFitFaceStatus",{},1,0],[["stock"],"SetStockSizeObject",{},1,0],[["stock"],"ConvertStockDataToBuilder",{},1,0],[["stockFeature"],"MakeStockCurrentFeatureForEdit",{},1,0],[["selBodyOcc"],"ChangeWorkPartOnSelecting",{},1,0]],[]];
SPLM.Tooling.StockSizeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.StockSizeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.StockSizeBuilder.Types = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder"});

SPLM.Tooling.StockSizeBuilder.RefCsysType = Object.freeze({
    "Wcs" : "Wcs", "AbsoluteDisplayedPart" : "AbsoluteDisplayedPart", "SelectedCSYS" : "SelectedCSYS"});

SPLM.Tooling.StockSizeBuilder.AlignedBlockType = Object.freeze({
    "Csys" : "Csys", "Vector" : "Vector", "NonAligned" : "NonAligned"});

SPLM.Tooling.StockSizeBuilder.Shape = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder"});

SPLM.Tooling.StockSizeBuilder.Cylinder = Object.freeze({
    "Circumscribed" : "Circumscribed", "InscribedCircle" : "InscribedCircle"});

export default SPLM;